<div fxLayout="column" fxLayoutAlign="center center" class="idle-check-wrapper">
  <h1 mat-dialog-title>You still there?</h1>
  <div mat-dialog-content class="idle-check-content">
    <p class="countdown-message">
      You will be automatically logged out in
      <br />
      <b>
        @if (timeoutMinutes > 0) {
          <span
            >{{ timeoutMinutes }}&nbsp;
            @if (timeoutMinutes != 1) {
              <span>minutes</span>
            }
            @if (timeoutMinutes == 1) {
              <span>minute</span>
              }&nbsp;
            </span>
          }
          {{ timeoutSeconds }}&nbsp;
          @if (timeoutSeconds != 1) {
            <span>seconds</span>
          }
          @if (timeoutSeconds == 1) {
            <span>second</span>
          }
        </b>
        <br />
        if no button is clicked.
      </p>
    </div>
    <div mat-dialog-actions>
      <button
        aria-label="Log me out."
        mat-raised-button
        color="warn"
        (click)="logout()"
        >
        Log me out.
      </button>
      <button
        #keepMeSignedInBtn
        aria-label="Keep me signed in!"
        mat-raised-button
        color="primary"
        cdkFocusInitial
        (click)="keepMeLoggedIn()"
        >
        Keep me signed in!
      </button>
    </div>
  </div>
